module.exports = __webpack_public_path__ + "img/1-sm.3f111ce2.jpg";